'use strict';

import React from 'react';
import classNames from 'classnames';
import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';

class TargetLabelTableComponent extends React.Component {

  getAdditionalRowClassName (isSelected) {
    return classNames({
      'Selectable': true,
      'Selected': isSelected
    });
  }

  renderTableRows () {
    const { rowOnClick, targetLabels, classifierId, selectedClfTargetId } = this.props;
    let tableRows = [];
    if (targetLabels.length > 0) {
      tableRows = targetLabels.map((item) => {
        const { clfTargetId, targetLabel } = item;
        const { id, name } = targetLabel;
        const isSelected = selectedClfTargetId === clfTargetId;
        return (
          <TableRow key={clfTargetId} onClick={rowOnClick.bind(this, classifierId, clfTargetId, id)} className={this.getAdditionalRowClassName(isSelected)}>
            <TableData>{clfTargetId}</TableData>
            <TableData>{id}</TableData>
            <TableData>{name}</TableData>
          </TableRow>
        );
      });
    } else {
      tableRows.push(
        <TableRow key='empty-cfl-target-table'>
          <TableData style={{maxWidth: 30+'px'}}>No Classifier Selected</TableData>
          <TableData></TableData>
          <TableData></TableData>
        </TableRow>
      );
    }

    return tableRows;
  }

  render () {
    return (
      <Table scrollable>
        <thead>
          <TableRow isHeader>
            <TableHeader>Clf Target Id</TableHeader>
            <TableHeader>Target Label Id</TableHeader>
            <TableHeader>Target Label Name</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          { this.renderTableRows() }
        </tbody>
      </Table>
    );
  }
}

export default TargetLabelTableComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetLabelTable.component.jsx